import { State } from 'modules';

export const isReplyOpen = (state: State, id: string) => {
  return state.ui.superHome.openReplies.some((openId) => openId === id);
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/super-home.ts